require('./RASuitabilityTestModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKMessage } = require('commonsComponents/OKMessage');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatDate } = require('utilities/dateHelper');

// @constants
const {
    RA_MODAL_TYPE_3,
    RA_MODAL_TYPE_5,
    RA_MODAL_TYPE_6,
} = require('../../raConstants/index');

class RASuitabilityTestModal extends React.Component {
    buildModalImage() {
        let modalImage;

        if (!!this.props.typeGBI) {
            const classImage = `ra-suitability-test-modal__image ra-suitability-test-modal__image-${this.props.typeGBI}`;
            modalImage = <div className={classImage} />;
        } else {
            modalImage = <div className="ra-suitability-test-modal__icon" />;
        }

        return modalImage;
    }

    buildModalTitle() {
        const { identifier } = this.props;
        let injectedStrings;

        if (identifier === RA_MODAL_TYPE_3) {
            injectedStrings = [formatDate(this.props.testDate, 'DATE_FORMAT')];
        }

        return formatText(
            `raSuitabilityTestModal-raSuitabilityTestModal_title${identifier}`,
            injectedStrings,
        );
    }

    buildModalNotification() {
        const { identifier } = this.props;
        let modalNotification;

        if (identifier === RA_MODAL_TYPE_5 || identifier === RA_MODAL_TYPE_6) {
            modalNotification = (
                <div className="ra-suitability-test-modal__notification">
                    <OKMessage type="informative">
                        <FormattedText
                            value={`raSuitabilityTestModal-raSuitabilityTestModal_notification${identifier}`}
                        />
                    </OKMessage>
                </div>
            );
        }

        return modalNotification;
    }

    selectFooterType() {
        const { identifier } = this.props;

        let footerType = 'action';
        if ([RA_MODAL_TYPE_5, RA_MODAL_TYPE_6].includes(identifier)) {
            footerType = 'navigation';
        }

        return footerType;
    }

    selectSecondaryButtonOptions() {
        const { identifier, secondaryButtonAction } = this.props;
        let secondaryButtonText;
        let secondaryButtonCallback;

        if (identifier === RA_MODAL_TYPE_3) {
            secondaryButtonText = `raSuitabilityTestModal-raSuitabilityTestModal_secondaryButton${identifier}`;
            secondaryButtonCallback = secondaryButtonAction;
        }

        return [secondaryButtonText, secondaryButtonCallback];
    }

    render() {
        const { closeModal, identifier, primaryButtonAction } = this.props;
        const modalImage = this.buildModalImage();
        const modalTitle = this.buildModalTitle();
        const modalNotification = this.buildModalNotification();
        const footerType = this.selectFooterType();
        const [
            secondaryButtonText,
            secondaryButtonCallback,
        ] = this.selectSecondaryButtonOptions();

        return (
            <OKModal
                content={modalNotification}
                description={`raSuitabilityTestModal-raSuitabilityTestModal_subtitle${identifier}`}
                descriptionAlignment="center"
                footerType={footerType}
                headerContent={modalImage}
                headerType="custom"
                isOpen={true}
                onCloseCallback={closeModal}
                onPrimaryButtonClick={primaryButtonAction}
                onSecondaryButtonClick={secondaryButtonCallback}
                primaryButtonText={`raSuitabilityTestModal-raSuitabilityTestModal_primaryButton${identifier}`}
                secondaryButtonText={secondaryButtonText}
                shouldCloseOnOverlayClick={false}
                title={modalTitle}
                titleAlignment="center"
            />
        );
    }
}

RASuitabilityTestModal.propTypes = {
    closeModal: PropTypes.func,
    identifier: PropTypes.number,
    primaryButtonAction: PropTypes.func,
    secondaryButtonAction: PropTypes.func,
    testDate: PropTypes.string,
    typeGBI: PropTypes.oneOf(['car', 'education', 'home', 'others', 'travel']),
};

module.exports = RASuitabilityTestModal;
